import React, { useState } from "react";
import PropTypes from "prop-types";
import { contentParserOptions } from "../../utils/parser";
import parse from "html-react-parser";
import { dropDown } from "../../assets/images/icons";
import { CLASSES } from "../../utils/constants";
import "./CollapsibleContent.scss";
const { COLLAPSIBLE_SECTION } = CLASSES;

const CollapsibleContent = ({ content, heading }) => {
  const [isCollapsed, setIsCollapse] = useState(true);

  return (
    <div className={COLLAPSIBLE_SECTION.SECTION}>
      <div
        className={COLLAPSIBLE_SECTION.HEADING}
        onClick={() => setIsCollapse(value => !value)}
      >
        <h2>{heading}</h2>
        <div
          className={`${COLLAPSIBLE_SECTION.SPAN}
            ${isCollapsed ? "" : "rotate"}`}
        >
          {parse(dropDown)}
        </div>
      </div>
      <div
        className={`${COLLAPSIBLE_SECTION.CONTENT} 
          ${isCollapsed ? "hide" : ""}`}
      >
        {content?.map(contentItem => {
          return parse(contentItem, contentParserOptions);
        })}
      </div>
    </div>
  );
};

CollapsibleContent.propTypes = {
  content: PropTypes.array,
  heading: PropTypes.string,
};
export default CollapsibleContent;
